export default __webpack_public_path__ + "static/media/infrastructure_open.5f65cabf.png";